import { render } from "./SelectModal.vue?vue&type=template&id=664a3ced&scoped=true&ts=true"
import script from "./SelectModal.vue?vue&type=script&lang=ts"
export * from "./SelectModal.vue?vue&type=script&lang=ts"

import "./SelectModal.vue?vue&type=style&index=0&id=664a3ced&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664a3ced"]])

export default __exports__